var exports = {
  "kI": "highlightedOverlayInCodeLine__zL1UYu",
  "ak": "highlighterElement__ibzapQ",
  "vD": "highlighterElementSubtle__3uZL4s",
  "aZ": "highlighterElementActive__6MsBOF",
  "mK": "highlighterElementSafari__ugKJO0",
  "Oj": "reactCodeTextCell__olVy_G",
};

module.exports = exports;
